import { Link, useNavigate } from "react-router-dom";
import config from "../config";

const Footer = ({t, pages}) => {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer-container">
        
        <div className="footer-left">
          <div className="footer-left-1">
            <div onClick={() => navigate('/')} style={{cursor: "pointer"}}><img src={config.globalLogo} alt="Logo" className="footer-logo" /></div>
            
            <div className="social-links-2">
              <div>
                <a className="a-footer" href={"https://wa.me/"+t("footer.phone", { returnObjects: true })}>
                <img src="/images/social_network/icons8-whatsapp-48.png" alt="Whatsapp" className="social-icon" style={{ verticalAlign: "middle", marginRight: "8px" }} />
                {t("footer.phone", { returnObjects: true })}
                </a>
              </div>
              <div>
                <a className="a-footer" href="https://www.instagram.com/coworking_mazarron?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer">
                <img src="/images/social_network/icons8-instagram-48.png"  alt="Instagram" className="social-icon" style={{ verticalAlign: "middle", marginRight: "8px" }}  />
                coworking_mazarron
              </a>
              </div>
              <div><a className="a-footer" href={"mailto:"+t("footer.email", { returnObjects: true })}>{t("footer.email", { returnObjects: true })}</a></div>
            </div>
            {/* 
            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <img src="/images/social_network/icons8-facebook-48.png" alt="Facebook" className="social-icon" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <img src="/images/social_network/icons8-instagram-48.png"  alt="Instagram" className="social-icon" />
              </a>
            </div>
             */}
          </div>

          <div className="footer-left-2">
            <h2 className="content-h2-no-margin">{t("footer.title", { returnObjects: true })}</h2>
            <nav className="footer-menu">
              {Object.keys(pages).map((key) => {
                const { title, to, hide, logo, submenus } = pages[key];
                
                if (hide || logo) {
                  return null;
                }

                if (submenus) {
                  return (
                    <div key={key} className="footer-submenu">
                      {Object.keys(submenus).map((submenuKey) => {
                        const { title: submenuTitle, to: submenuTo } = submenus[submenuKey];
                        return (
                          <Link key={submenuKey} className="footer-link" to={submenuTo}>{submenuTitle}</Link>
                        );
                      })}
                    </div>
                  );
                }

                return (
                  <Link key={key} className="footer-link" to={to}>{title}</Link>
                );
              })}
            </nav>
          </div>
        </div>

        <div className="footer-map">
        <iframe title="Location" src={config.globalIframeSrc} width="400" height="300" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div className="footer-address">
            {t("footer.address", { returnObjects: true })
              .split("\n")
              .map((line, index) => (
                <div key={index}>{line}</div>
              ))}
          </div>
        </div>

      </div>
      <div style={{ display: "flex", justifyContent: "center" }}><a className="a-footer a-info-legal">{t("footer.legal_information")}</a></div>
      {/* <div style={{ display: "flex", justifyContent: "center" }}><a href="https://abspots.com" className="a-footer a-info-legal">{t("footer.ownership")}</a></div> */}

    </footer>
  );
};

export default Footer;
